import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import Header from 'src/layouts/dashboard/header/header.component';
import { useTranslation } from 'react-i18next';

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

export default function NoPermissionComponent() {

  const { t: translate } = useTranslation();

  return (
    <>
      <Helmet>
        <title> {translate('no_permission.no_permission')} </title>
      </Helmet>
      <Header headerName={''} />
      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
          {translate('no_permission.permission')}
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
          {translate('no_permission.please_contact_admin')}
          </Typography>

          <Box
            component="img"
            src="/assets/illustrations/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          <Button to="/" size="large" variant="contained" component={RouterLink}>
          {translate('no_network.go_home')}
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
